/**
 *
 * OktaVerifyStepThree Component
 *
 */

import React from "react";
import classnames from "classnames";
import {
  Button,
  TextField,
  stylize,
  Enums,
} from "@envestnet/envreact-component-library";
import withIntl from "utils/withIntl";
import messages from "./messages";
import styles, { Styles } from "./styles";
import { StatusType } from "./types";
import { StatusTypeEnum } from "./enums";

const { ButtonSize, ButtonStyle } = Enums;

interface InjectedProps extends Styles {
  /** Internal - injected from withIntl */
  formatMessage: FormatMessage;

  /** Internal - injected from WithStyles */
  innerRef?: React.RefObject<HTMLDivElement>;
}

interface DefaultProps {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below
  onCancel: Function;
  onNext: Function;
  secretCode: string;
  status: StatusType;
}

export interface OktaVerifyStepThreeProps extends DefaultProps {
  /** CSS class name to be applied to top level component */
  className?: string;

  /** Inline style object to be applied to top level component */
  style?: React.CSSProperties;
}

const defaultProps: DefaultProps = {
  onCancel: () => {},
  onNext: () => {},
  secretCode: "",
  status: StatusTypeEnum.INITIAL,
};

type Props = InjectedProps & OktaVerifyStepThreeProps;

const OktaVerifyStepThree = (props: Props) => {
  const {
    classes,
    style,
    className,
    formatMessage,
    innerRef,
    onCancel,
    secretCode,
    onNext,
    status,
  } = props;

  return (
    <div
      ref={innerRef}
      className={classnames(className, classes.container)}
      style={style}
    >
      <div className={classnames(classes.descClass, "header-text-font-family")}>
        {formatMessage(messages.header)}
      </div>
      <div className={classnames(classes.infoClass, "header-text-font-family")}>
        {formatMessage(messages.info)}
      </div>
      <div data-testid="okta-verify-step-two-code-input">
        <TextField
          label={formatMessage(messages.keyTextField)}
          text={secretCode.match(/.{1,4}/g)?.join("  ")}
          textStyle={{fontFamily: "Red Hat Text"}}
          onChangeText={() => {}}
          disabled
          className={classnames(
            classes.textfield,
            "no-border-radius",
            "header-font-family"
          )}
          textFieldStyle={classes.disabledTextField}
        />
      </div>
      <div>
        <Button
          buttonStyle={ButtonStyle.Primary}
          buttonSize={ButtonSize.Regular}
          className={classnames(classes.verifyButton, "no-border-radius", "header-text-font-family")}
          name={formatMessage(messages.nextButtonLabel)}
          onClick={() => onNext()}
          loading={status === StatusTypeEnum.PROCESSING}
          aria-label="challenge question submit button"
        />
      </div>
      <div>
        <Button
          buttonStyle={ButtonStyle.Link}
          buttonSize={ButtonSize.Regular}
          className={classnames(classes.linkButton, "header-text-font-family")}
          name={formatMessage(messages.cancelButtonLabel)}
          onClick={() => {
            onCancel();
          }}
          aria-label="challenge question submit button"
        />
      </div>
    </div>
  );
};

OktaVerifyStepThree.defaultProps = defaultProps;

export default withIntl(
  stylize<Props, DefaultProps>(styles)(OktaVerifyStepThree)
);
